import { render, staticRenderFns } from "./deliveryLocationModal.vue?vue&type=template&id=9652faee"
import script from "./deliveryLocationModal.vue?vue&type=script&lang=js"
export * from "./deliveryLocationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports